var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuality(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3727_4170",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3727_4170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0834 17.875L15.2501 11.0417L17.0417 9.25L22.0834 14.3333L31.8334 4.625L33.5834 6.33333L22.0834 17.875ZM10.6251 31.6667L23.4167 35.4167L33.7501 32.1667C33.7501 31.6111 33.5348 31.1458 33.1042 30.7708C32.6737 30.3958 32.1667 30.2083 31.5834 30.2083H22.8751C22.4306 30.2083 21.9931 30.1736 21.5626 30.1042C21.132 30.0347 20.7084 29.9306 20.2917 29.7917L16.2917 28.5833L17.0834 26.0417L21.0001 27.375C21.3056 27.4861 21.6181 27.5694 21.9376 27.625C22.257 27.6806 22.5695 27.7083 22.8751 27.7083H25.2084C25.2084 27.125 25.014 26.6181 24.6251 26.1875C24.2362 25.7569 23.764 25.4306 23.2084 25.2083L14.1251 21.75H10.6251V31.6667ZM1.66675 36.6667V19.25H14.0834C14.2223 19.25 14.3681 19.2639 14.5209 19.2917C14.6737 19.3194 14.8195 19.3611 14.9584 19.4167L24.0417 22.8333C25.0973 23.2222 25.9931 23.8472 26.7292 24.7083C27.4654 25.5694 27.8334 26.5694 27.8334 27.7083H31.5834C33.0001 27.7083 34.2015 28.2222 35.1876 29.25C36.1737 30.2778 36.6667 31.5 36.6667 32.9167V34L23.6251 38L10.6251 34.2917V36.6667H1.66675ZM4.16675 34.1667H8.08342V21.75H4.16675V34.1667Z",
    fill: "#0089D6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuality);
export default __webpack_public_path__ + "static/media/quality.433efbbcd64293adaa7981ddf767e754.svg";
export { ForwardRef as ReactComponent };